import { ConfigValue } from "protos/config/api/config_service";
import { FunctionComponent } from "react";

interface Props {
  value: ConfigValue | undefined;
}
export const ConfigValueView: FunctionComponent<Props> = ({ value }) => {
  const v = value;
  if (!v) {
    return "";
  }
  if (v.stringVal !== undefined) {
    // render strings with quotes for readability
    return JSON.stringify(v.stringVal);
  }
  return String(v.int64Val ?? v.uint64Val ?? v.boolVal ?? v.floatVal ?? "");
};
